import { render } from "./DetalhesProduto.vue?vue&type=template&id=2cc3c149"
import script from "./DetalhesProduto.vue?vue&type=script&lang=js"
export * from "./DetalhesProduto.vue?vue&type=script&lang=js"

import "./DetalhesProduto.vue?vue&type=style&index=0&id=2cc3c149&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__